import { registerTourPage } from '@/composables/tour/tourRegistry';
import { step } from '@/composables/tour/stepHelpers';

registerTourPage('admin-permissions', {
  key: 'admin-permissions',
  label: 'Permissions',
  getSteps: () => [
    step({
      target: '#tour-permissions-tabs',
      title: 'Permissions Hub',
      content:
        'Control who can do what. "Manage Users" is for per-staff permissions, "Manage Groups" creates reusable role bundles, and the approval tabs let you review role requests staff have raised.',
      placement: 'bottom',
    }),
    step({
      target: '#tour-permissions-users',
      title: 'User Permissions',
      content:
        'Pick a user on the left, then on the right grant or revoke individual permissions, or assign a permission group to copy a whole role onto them.',
      placement: 'top',
    }),
    step({
      target: '#tour-permissions-groups',
      title: 'Permission Groups',
      content:
        'Create reusable bundles like "Class Staff" or "Bursar". Switch to this tab and click create to define one — then assign the group to staff in bulk.',
      placement: 'top',
    }),
    step({
      target: '#tour-permissions-documentation',
      title: 'Permission Documentation',
      content:
        'Not sure what a permission actually unlocks? This tab lists every one in plain English, straight from the server that enforces them.',
      placement: 'top',
    }),
  ],
});
